// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"1":"b0f77b03","453":"00861d26","794":"14fa7afb"}[chunkId] + ".chunk.js";
};